export const emailFields = {
  bodyHeading: null,
  bodyText: null,
  ctaHref: null,
  ctaText: null,
  subject: null
}


export const emails = {
  __typename: "Emails",
  notificationUserIds: null,
  senderName: null,
  senderUsername: null,
  userSurvey: {
    __typename: "EmailUserSurvey",
    ...emailFields
  },
  preSurveyReminder: {
    __typename: "EmailPreSurveyReminder",
    ...emailFields,
    hoursBefore: null
  },
  surveyOpenedNotification: {
    __typename: "EmailSurveyOpenedNotification",
    ...emailFields,
    enabled: null
  },
  userDeadlineReminder: {
    __typename: "EmailUserDeadlineReminder",
    ...emailFields,
    hoursBefore: null
  },
  userReminder: {
    __typename: "EmailUserReminder",
    ...emailFields,
    afterDays: null
  }
}

export const preferences = {
  __typename: "Preferences",
  actionBoardUrl: null,
  driverCommentTitle: null,
  eNPSPeriodType: null,
  eNPSPeriodValue: 0,
  groupIds: [],
  includeActionBoard: null,
  includeDriverComment: null,
  includeENPS: null,
  placeholders: {tenant: null, __typename: "Placeholders"},
  questionCount: null,
  sendToAll: null,
  teamIds: [],
  userIds: null,
  emails,
  questionSelectionType: null
}

const cycle = {
  __typename: "Schedule",
  id: "defaultDataId",
  createdAt: null,
  etag: null,
  Etag: null,
  interestId: null,
  lastENPSTriggeredAt: null,
  lastTriggeredAt: null,
  nextTriggerAt: null,
  nextTriggerAtOverride: null,
  periodType: null,
  periodValue: null,
  reference: null,
  runCount: null,
  startAt: null,
  status: null,
  tenant: null,
  runOnce: null,
  preferences
}

export default cycle
